import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col" data-id="element-91" data-mp="uw8b4obbxkad">
      <Header data-id="element-92" data-mp="77xgw4052iv2" />
      <main className="flex-grow pt-[88px]" data-id="element-93" data-mp="79rz3ak0zwvg">{children}</main>
      <Footer data-id="element-94" data-mp="29vxfhyswhj2" />
    </div>;
}